const updates = [
  { date: '2026-07-30', title: '平台新增AI智能推荐引擎', desc: '基于观影偏好和评分数据，智能匹配个性化精品影视推荐，发现好片更高效。' },
  { date: '2026-07-28', title: '深夜影院专区全新上线', desc: '精选适合夜间观看的高分佳作合辑，搭配暗色主题界面，打造沉浸式观影氛围。' },
  { date: '2026-07-25', title: '移动客户端2.0版本发布', desc: '全面优化播放内核，支持画中画模式和后台音频播放，离线缓存速度提升60%。' },
  { date: '2026-07-22', title: '片库突破25,000部大关', desc: '本月新增800+优质影片资源，涵盖戛纳、威尼斯等国际电影节获奖作品。' },
  { date: '2026-07-18', title: '播放体验全面优化升级', desc: '智能码率适配算法迭代，弱网环境下播放成功率提升至99.7%，缓冲时间降低70%。' },
  { date: '2026-07-15', title: '专题合集功能改版上线', desc: '全新视觉设计，支持按年代、导演、演员多维度筛选，专题内容每日自动更新。' },
  { date: '2026-07-10', title: '社区频道开启内测', desc: '用户可在精选推荐页面参与评分和短评互动，优质影评将获得首页展示机会。' },
  { date: '2026-07-05', title: '暑期观影季活动启动', desc: '7月-8月推出暑期特别策划，涵盖动作大片周、动画嘉年华等主题活动，每日更新推荐清单。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关注91在线视频的最新功能更新与内容动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updates.slice(0, 8).map((item, i) => (
              <div key={i} className="relative flex gap-5 pl-12">
                <div className="absolute left-0 top-1 w-[38px] h-[38px] rounded-full bg-background-50 border-2 border-accent-300 flex items-center justify-center flex-shrink-0">
                  <div className="w-2.5 h-2.5 rounded-full bg-accent-500"></div>
                </div>
                <div className="bg-background-50 rounded-xl p-4 flex-1">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <h3 className="font-heading text-sm font-semibold text-foreground-900">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}